import { Input, Button, Form, Modal, Collapse, List, Popconfirm, Select } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { addProductType, modifyProductType, loadOrificeConfigByProdTypeID, removeOrificeConfig } from "./ProductTypeSlice";
import { CommonContext, CommonContextType } from "../../contexts/CommonContext";
import AddOrificeConfig from "./AddOrificeConfig";
import { useSelector } from "react-redux";
import { AppState } from "../../redux/store/rootReducer";
import { FileAddOutlined, DeleteOutlined, EditOutlined, InboxOutlined } from '@ant-design/icons';

const { Panel } = Collapse;
export default function AddProductType(): JSX.Element {
  const dispatch = useDispatch();
  const { setModelChange, messageApi, editBodySize, setEditBodySize, isModalOpen1, setModelChange1 } =
    React.useContext(CommonContext) as CommonContextType;
  const [form] = Form.useForm();
  const Cat = useSelector((state: AppState) => state.Category);
  const [connSizeIdData, setConnSizeIdData] = useState<number>();
  const fields = useSelector((state: AppState) => state.ProductTypes);
  const [cat_array, setCatArray] = useState([{}]);

  useEffect(() => {
    if (Cat.CategoryArr.length > 0) {
      const arr = Cat.CategoryArr.map((el: any) => ({ value: el.id, label: el.category_name }))
      setCatArray(arr);
    }

  }, [Cat]);
  React.useEffect(() => {
    if (editBodySize?.id) {
      dispatch(loadOrificeConfigByProdTypeID(editBodySize?.id));
      form.setFieldsValue(editBodySize);
      form.setFieldsValue(Object.assign({ category_name: editBodySize?.category?.id },editBodySize))
    }
  }, [editBodySize, form]);

  const onFinish = (values: any) => {
    values.category = values.category_name;
    delete(values.category_name)
    if (editBodySize?.id) {
      //form type is edit
      values.updated_datetime = new Date().toLocaleString() + "";
      dispatch(modifyProductType(values, editBodySize?.id));
     /*  messageApi.open({
        type: "success",
        content: "Product Type updated successfully",
      }); */
    } else {
      values.created_datetime = new Date().toLocaleString() + "";
      dispatch(addProductType(values));
    }
    setModelChange(false);
    setEditBodySize(null);
    form.resetFields();
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };
  const showModalConnSize = () => {

    setConnSizeIdData(editBodySize?.id);
    setModelChange1(true);

  };
  const handleCancel = () => {
    setModelChange1(false);
    // setIsModalTwoOpen(false)
  };
  const handleDelete = (id: number) => {
    console.log(id)
    dispatch(removeOrificeConfig(id));
  };

  /*   const genExtra = (data: any) => (
      <div className='first_class'>
        <div className='sub_data' style={{ marginLeft: '20px', width: '30%' }}><b>Body Size:</b> {data?.body_size?.bodysize_value}</div>
        <div className='sub_data' style={{ marginLeft: '20px', width: '50%' }}><b>Orifice Size:</b> {data?.orifice_size}</div>
        <Popconfirm title="Sure to delete?" onConfirm={() => handleDeleteConnSize(data.id)}>
          <DeleteOutlined style={{ width: '7%', color: 'red', fontSize: '150%' }} />
        </Popconfirm>
      </div>
    );
   */
  return (
    <Form
      form={form}
      layout={"vertical"}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Form.Item label="Category"
        name='category_name'
        rules={[
          {
            required: true,
            message: 'Please enter category',
          },
        ]}>
        <Select
          // style={{ width: 120 }}
          options={cat_array}
        />
      </Form.Item>

      <Form.Item
        label="Product Type"
        name="type_name"
        rules={[
          {
            required: true,
            message: "Please enter Product Type",
          }
        ]}
      >
        <Input />
      </Form.Item>


      <Form.Item>
        <Button className='submit-button' type="primary" htmlType="submit" >{editBodySize?.id ? 'Update' : 'Create'}</Button>
      </Form.Item>

      <Modal title='Create Orifice Size' open={isModalOpen1} onCancel={handleCancel} maskClosable={false} footer={null}>
        <AddOrificeConfig productTypeId={connSizeIdData} />
      </Modal>


      {(editBodySize?.category?.category_code == 'VALVE') ? <Button className='button' type="primary" htmlType="button" onClick={showModalConnSize}>Add Orifice Size</Button> : null}

      {(editBodySize?.category?.category_code == 'VALVE') ?
        <List
          className="demo-loadmore-list"
          itemLayout="horizontal"
          dataSource={fields?.OrificeConfig}
          renderItem={(item: any, index) => (
            <List.Item key={item.id}
              actions={
                [
                  <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(item?.id)}>
                    <DeleteOutlined style={{ color: 'red' }} />
                  </Popconfirm>]}>

              <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                <div style={{ width: '50%' }}><b>Body Size:</b> {item?.body_size} </div>
                <div style={{ marginLeft: '11px', width: '50%' }}><b>Orifice Size:</b> {item?.orifice_size}</div>
              </div>
            </List.Item>
          )}
        />

        : null}
    </Form>
  );

}
